import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M8 1.25A6.75 6.75 0 1 0 14.75 8 6.76 6.76 0 0 0 8 1.25Zm0 12A5.25 5.25 0 1 1 13.25 8 5.26 5.26 0 0 1 8 13.25ZM11.52 8a.75.75 0 0 1-.75.75h-2v2a.75.75 0 0 1-1.5 0v-2h-2a.75.75 0 0 1 0-1.5h2v-2a.75.75 0 0 1 1.5 0v2h2a.76.76 0 0 1 .75.75Z';
const draw24px =
  'M12,2.25A9.75,9.75,0,1,0,21.75,12,9.76,9.76,0,0,0,12,2.25Zm0,18A8.25,8.25,0,1,1,20.25,12,8.26,8.26,0,0,1,12,20.25ZM17.75,12a.75.75,0,0,1-.75.75H12.75V17a.75.75,0,0,1-1.5,0V12.75H7a.75.75,0,0,1,0-1.5h4.25V7a.75.75,0,0,1,1.5,0v4.25H17A.76.76,0,0,1,17.75,12Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const PlusCircleIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'plusCircle'),
) as IconWithRender;

PlusCircleIcon.displayName = 'PlusCircleIcon';
PlusCircleIcon.propTypes = Icon.propTypes;
PlusCircleIcon.renderIcon = (props) => <PlusCircleIcon {...props} />;
export default PlusCircleIcon;
